import { FunctionComponent } from 'react';

interface FieldLabelProps {
  id: string;
  label: string;
  optional?: boolean;
}

const FieldLabel: FunctionComponent<FieldLabelProps> = ({ id, label, optional }) => {
  return (
    <label htmlFor={id} className="text-secondary-std block text-sm font-medium leading-6">
      {label} {optional ? <span className="ml-1 text-gray-400 font-normal">(optional)</span> : <span className="text-red-500 ml-0.5">*</span>}
    </label>
  );
};

export default FieldLabel;
